/**
 * Portfolio (retired in Sprint P13).
 *
 * The pit-sweep portfolio view has been removed along with the rest of
 * Pit Optimisation / Mine Planning. Left in place as a placeholder so
 * legacy links don't 404.
 */
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Info } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";


export default function PortfolioPage() {
  const nav = useNavigate();
  return (
    <div className="p-8 max-w-2xl mx-auto space-y-4"
          data-testid="portfolio-retired">
      <div className="rounded-lg border border-slate-200 bg-white p-6 space-y-3">
        <Info size={24} className="text-slate-500" />
        <h2 className="text-lg font-bold text-slate-800">
          Portfolio Pit Sweep — removed
        </h2>
        <p className="text-sm text-slate-600">
          Pit Optimisation and Mine Planning were retired in Sprint P13.
          Every project now flows through the 10-step Resource Wizard
          ending at CPR Generation. Reopen any project to launch the
          wizard.
        </p>
        <Button variant="outline" size="sm" onClick={() => nav("/app")}
                 data-testid="portfolio-back">
          <ArrowLeft size={12} className="mr-1" /> Back to projects
        </Button>
      </div>
    </div>
  );
}
